export const Photo = ({ width = '21', height = '20' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5 2C17.1569 2 18.5 3.34315 18.5 5V15C18.5 16.6569 17.1569 18 15.5 18H5.5C3.84315 18 2.5 16.6569 2.5 15V5C2.5 3.34315 3.84315 2 5.5 2H15.5ZM15.5 4H5.5C4.94772 4 4.5 4.44772 4.5 5V12.697L6.68627 9.41876C7.00017 8.9793 7.59949 8.87371 8.04124 9.15898L8.14018 9.23178L13.2853 13.5193L16.5 7.745V5C16.5 4.44772 16.0523 4 15.5 4ZM7 8C7.82843 8 8.5 7.32843 8.5 6.5C8.5 5.67157 7.82843 5 7 5C6.17157 5 5.5 5.67157 5.5 6.5C5.5 7.32843 6.17157 8 7 8Z"
        fill="#121212"
      />
    </svg>
  );
};
